import { API } from 'core/requests'
import { useQuery, UseQueryResult } from 'react-query'

export const useFetchCompanies: () => UseQueryResult<any[], Error> = () => {
  return useQuery('invoices', () => API.get('companies'))
}
